var map = {
	"./admin.svg": "fd36",
	"./bronze.svg": "2238",
	"./gold.svg": "ab0b",
	"./mod.svg": "abeb",
	"./partner.svg": "cce0b",
	"./platinum.svg": "bac5",
	"./silver.svg": "762a",
	"./titanium.svg": "cc87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0cf8";